/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AiSubscriptionsBangladeshRouteImport } from './routes/ai-subscriptions-bangladesh'
import { Route as CartRouteImport } from './routes/cart'
import { Route as ChatgptPlusPriceBangladeshRouteImport } from './routes/chatgpt-plus-price-bangladesh'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as GeminiAdvancedPriceBangladeshRouteImport } from './routes/gemini-advanced-price-bangladesh'
import { Route as LovableProPriceBangladeshRouteImport } from './routes/lovable-pro-price-bangladesh'
import { Route as OrderSuccessRouteImport } from './routes/order-success'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ProductsRouteImport } from './routes/products'
import { Route as RefundPolicyRouteImport } from './routes/refund-policy'
import { Route as SupabaseProPriceBangladeshRouteImport } from './routes/supabase-pro-price-bangladesh'
import { Route as SupportRouteImport } from './routes/support'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AccountOrdersRouteImport } from './routes/account.orders'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminBannersRouteImport } from './routes/admin.banners'
import { Route as AdminInventoryRouteImport } from './routes/admin.inventory'
import { Route as AdminOrdersRouteImport } from './routes/admin.orders'
import { Route as AdminPaymentsRouteImport } from './routes/admin.payments'
import { Route as AdminProductsRouteImport } from './routes/admin.products'
import { Route as AdminProvidersRouteImport } from './routes/admin.providers'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as ProductsIndexRouteImport } from './routes/products.index'
import { Route as ProductsProductSlugRouteImport } from './routes/products.$productSlug'
import { Route as AccountOrdersIndexRouteImport } from './routes/account.orders.index'
import { Route as AccountOrdersOrderIdRouteImport } from './routes/account.orders.$orderId'
import { Route as ProductsCategoryCategorySlugRouteImport } from './routes/products.category.$categorySlug'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AiSubscriptionsBangladeshRoute =
  AiSubscriptionsBangladeshRouteImport.update({
    id: '/ai-subscriptions-bangladesh',
    path: '/ai-subscriptions-bangladesh',
    getParentRoute: () => rootRouteImport,
  } as any)
const CartRoute = CartRouteImport.update({
  id: '/cart',
  path: '/cart',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatgptPlusPriceBangladeshRoute =
  ChatgptPlusPriceBangladeshRouteImport.update({
    id: '/chatgpt-plus-price-bangladesh',
    path: '/chatgpt-plus-price-bangladesh',
    getParentRoute: () => rootRouteImport,
  } as any)
const CheckoutRoute = CheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRouteImport,
} as any)
const GeminiAdvancedPriceBangladeshRoute =
  GeminiAdvancedPriceBangladeshRouteImport.update({
    id: '/gemini-advanced-price-bangladesh',
    path: '/gemini-advanced-price-bangladesh',
    getParentRoute: () => rootRouteImport,
  } as any)
const LovableProPriceBangladeshRoute =
  LovableProPriceBangladeshRouteImport.update({
    id: '/lovable-pro-price-bangladesh',
    path: '/lovable-pro-price-bangladesh',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrderSuccessRoute = OrderSuccessRouteImport.update({
  id: '/order-success',
  path: '/order-success',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsRoute = ProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => rootRouteImport,
} as any)
const RefundPolicyRoute = RefundPolicyRouteImport.update({
  id: '/refund-policy',
  path: '/refund-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const SupabaseProPriceBangladeshRoute =
  SupabaseProPriceBangladeshRouteImport.update({
    id: '/supabase-pro-price-bangladesh',
    path: '/supabase-pro-price-bangladesh',
    getParentRoute: () => rootRouteImport,
  } as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountOrdersRoute = AccountOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AccountRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBannersRoute = AdminBannersRouteImport.update({
  id: '/banners',
  path: '/banners',
  getParentRoute: () => AdminRoute,
} as any)
const AdminInventoryRoute = AdminInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrdersRoute = AdminOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPaymentsRoute = AdminPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProductsRoute = AdminProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProvidersRoute = AdminProvidersRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const ProductsIndexRoute = ProductsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProductsRoute,
} as any)
const ProductsProductSlugRoute = ProductsProductSlugRouteImport.update({
  id: '/$productSlug',
  path: '/$productSlug',
  getParentRoute: () => ProductsRoute,
} as any)
const AccountOrdersIndexRoute = AccountOrdersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AccountOrdersRoute,
} as any)
const AccountOrdersOrderIdRoute = AccountOrdersOrderIdRouteImport.update({
  id: '/$orderId',
  path: '/$orderId',
  getParentRoute: () => AccountOrdersRoute,
} as any)
const ProductsCategoryCategorySlugRoute =
  ProductsCategoryCategorySlugRouteImport.update({
    id: '/category/$categorySlug',
    path: '/category/$categorySlug',
    getParentRoute: () => ProductsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/ai-subscriptions-bangladesh': typeof AiSubscriptionsBangladeshRoute
  '/cart': typeof CartRoute
  '/chatgpt-plus-price-bangladesh': typeof ChatgptPlusPriceBangladeshRoute
  '/checkout': typeof CheckoutRoute
  '/gemini-advanced-price-bangladesh': typeof GeminiAdvancedPriceBangladeshRoute
  '/lovable-pro-price-bangladesh': typeof LovableProPriceBangladeshRoute
  '/order-success': typeof OrderSuccessRoute
  '/privacy': typeof PrivacyRoute
  '/products': typeof ProductsRouteWithChildren
  '/refund-policy': typeof RefundPolicyRoute
  '/supabase-pro-price-bangladesh': typeof SupabaseProPriceBangladeshRoute
  '/support': typeof SupportRoute
  '/terms': typeof TermsRoute
  '/account/orders': typeof AccountOrdersRouteWithChildren
  '/admin/banners': typeof AdminBannersRoute
  '/admin/inventory': typeof AdminInventoryRoute
  '/admin/orders': typeof AdminOrdersRoute
  '/admin/payments': typeof AdminPaymentsRoute
  '/admin/products': typeof AdminProductsRoute
  '/admin/providers': typeof AdminProvidersRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/products/$productSlug': typeof ProductsProductSlugRoute
  '/admin/': typeof AdminIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/account/orders/$orderId': typeof AccountOrdersOrderIdRoute
  '/products/category/$categorySlug': typeof ProductsCategoryCategorySlugRoute
  '/account/orders/': typeof AccountOrdersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRouteWithChildren
  '/ai-subscriptions-bangladesh': typeof AiSubscriptionsBangladeshRoute
  '/cart': typeof CartRoute
  '/chatgpt-plus-price-bangladesh': typeof ChatgptPlusPriceBangladeshRoute
  '/checkout': typeof CheckoutRoute
  '/gemini-advanced-price-bangladesh': typeof GeminiAdvancedPriceBangladeshRoute
  '/lovable-pro-price-bangladesh': typeof LovableProPriceBangladeshRoute
  '/order-success': typeof OrderSuccessRoute
  '/privacy': typeof PrivacyRoute
  '/refund-policy': typeof RefundPolicyRoute
  '/supabase-pro-price-bangladesh': typeof SupabaseProPriceBangladeshRoute
  '/support': typeof SupportRoute
  '/terms': typeof TermsRoute
  '/admin/banners': typeof AdminBannersRoute
  '/admin/inventory': typeof AdminInventoryRoute
  '/admin/orders': typeof AdminOrdersRoute
  '/admin/payments': typeof AdminPaymentsRoute
  '/admin/products': typeof AdminProductsRoute
  '/admin/providers': typeof AdminProvidersRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/products/$productSlug': typeof ProductsProductSlugRoute
  '/admin': typeof AdminIndexRoute
  '/products': typeof ProductsIndexRoute
  '/account/orders/$orderId': typeof AccountOrdersOrderIdRoute
  '/products/category/$categorySlug': typeof ProductsCategoryCategorySlugRoute
  '/account/orders': typeof AccountOrdersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/ai-subscriptions-bangladesh': typeof AiSubscriptionsBangladeshRoute
  '/cart': typeof CartRoute
  '/chatgpt-plus-price-bangladesh': typeof ChatgptPlusPriceBangladeshRoute
  '/checkout': typeof CheckoutRoute
  '/gemini-advanced-price-bangladesh': typeof GeminiAdvancedPriceBangladeshRoute
  '/lovable-pro-price-bangladesh': typeof LovableProPriceBangladeshRoute
  '/order-success': typeof OrderSuccessRoute
  '/privacy': typeof PrivacyRoute
  '/products': typeof ProductsRouteWithChildren
  '/refund-policy': typeof RefundPolicyRoute
  '/supabase-pro-price-bangladesh': typeof SupabaseProPriceBangladeshRoute
  '/support': typeof SupportRoute
  '/terms': typeof TermsRoute
  '/account/orders': typeof AccountOrdersRouteWithChildren
  '/admin/banners': typeof AdminBannersRoute
  '/admin/inventory': typeof AdminInventoryRoute
  '/admin/orders': typeof AdminOrdersRoute
  '/admin/payments': typeof AdminPaymentsRoute
  '/admin/products': typeof AdminProductsRoute
  '/admin/providers': typeof AdminProvidersRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/products/$productSlug': typeof ProductsProductSlugRoute
  '/admin/': typeof AdminIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/account/orders/$orderId': typeof AccountOrdersOrderIdRoute
  '/products/category/$categorySlug': typeof ProductsCategoryCategorySlugRoute
  '/account/orders/': typeof AccountOrdersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/admin'
    | '/ai-subscriptions-bangladesh'
    | '/cart'
    | '/chatgpt-plus-price-bangladesh'
    | '/checkout'
    | '/gemini-advanced-price-bangladesh'
    | '/lovable-pro-price-bangladesh'
    | '/order-success'
    | '/privacy'
    | '/products'
    | '/refund-policy'
    | '/supabase-pro-price-bangladesh'
    | '/support'
    | '/terms'
    | '/account/orders'
    | '/admin/banners'
    | '/admin/inventory'
    | '/admin/orders'
    | '/admin/payments'
    | '/admin/products'
    | '/admin/providers'
    | '/admin/settings'
    | '/products/$productSlug'
    | '/admin/'
    | '/products/'
    | '/account/orders/$orderId'
    | '/products/category/$categorySlug'
    | '/account/orders/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/ai-subscriptions-bangladesh'
    | '/cart'
    | '/chatgpt-plus-price-bangladesh'
    | '/checkout'
    | '/gemini-advanced-price-bangladesh'
    | '/lovable-pro-price-bangladesh'
    | '/order-success'
    | '/privacy'
    | '/refund-policy'
    | '/supabase-pro-price-bangladesh'
    | '/support'
    | '/terms'
    | '/admin/banners'
    | '/admin/inventory'
    | '/admin/orders'
    | '/admin/payments'
    | '/admin/products'
    | '/admin/providers'
    | '/admin/settings'
    | '/products/$productSlug'
    | '/admin'
    | '/products'
    | '/account/orders/$orderId'
    | '/products/category/$categorySlug'
    | '/account/orders'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/admin'
    | '/ai-subscriptions-bangladesh'
    | '/cart'
    | '/chatgpt-plus-price-bangladesh'
    | '/checkout'
    | '/gemini-advanced-price-bangladesh'
    | '/lovable-pro-price-bangladesh'
    | '/order-success'
    | '/privacy'
    | '/products'
    | '/refund-policy'
    | '/supabase-pro-price-bangladesh'
    | '/support'
    | '/terms'
    | '/account/orders'
    | '/admin/banners'
    | '/admin/inventory'
    | '/admin/orders'
    | '/admin/payments'
    | '/admin/products'
    | '/admin/providers'
    | '/admin/settings'
    | '/products/$productSlug'
    | '/admin/'
    | '/products/'
    | '/account/orders/$orderId'
    | '/products/category/$categorySlug'
    | '/account/orders/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRouteWithChildren
  AdminRoute: typeof AdminRouteWithChildren
  AiSubscriptionsBangladeshRoute: typeof AiSubscriptionsBangladeshRoute
  CartRoute: typeof CartRoute
  ChatgptPlusPriceBangladeshRoute: typeof ChatgptPlusPriceBangladeshRoute
  CheckoutRoute: typeof CheckoutRoute
  GeminiAdvancedPriceBangladeshRoute: typeof GeminiAdvancedPriceBangladeshRoute
  LovableProPriceBangladeshRoute: typeof LovableProPriceBangladeshRoute
  OrderSuccessRoute: typeof OrderSuccessRoute
  PrivacyRoute: typeof PrivacyRoute
  ProductsRoute: typeof ProductsRouteWithChildren
  RefundPolicyRoute: typeof RefundPolicyRoute
  SupabaseProPriceBangladeshRoute: typeof SupabaseProPriceBangladeshRoute
  SupportRoute: typeof SupportRoute
  TermsRoute: typeof TermsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-subscriptions-bangladesh': {
      id: '/ai-subscriptions-bangladesh'
      path: '/ai-subscriptions-bangladesh'
      fullPath: '/ai-subscriptions-bangladesh'
      preLoaderRoute: typeof AiSubscriptionsBangladeshRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cart': {
      id: '/cart'
      path: '/cart'
      fullPath: '/cart'
      preLoaderRoute: typeof CartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chatgpt-plus-price-bangladesh': {
      id: '/chatgpt-plus-price-bangladesh'
      path: '/chatgpt-plus-price-bangladesh'
      fullPath: '/chatgpt-plus-price-bangladesh'
      preLoaderRoute: typeof ChatgptPlusPriceBangladeshRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout': {
      id: '/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof CheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gemini-advanced-price-bangladesh': {
      id: '/gemini-advanced-price-bangladesh'
      path: '/gemini-advanced-price-bangladesh'
      fullPath: '/gemini-advanced-price-bangladesh'
      preLoaderRoute: typeof GeminiAdvancedPriceBangladeshRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lovable-pro-price-bangladesh': {
      id: '/lovable-pro-price-bangladesh'
      path: '/lovable-pro-price-bangladesh'
      fullPath: '/lovable-pro-price-bangladesh'
      preLoaderRoute: typeof LovableProPriceBangladeshRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/order-success': {
      id: '/order-success'
      path: '/order-success'
      fullPath: '/order-success'
      preLoaderRoute: typeof OrderSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products': {
      id: '/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof ProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/refund-policy': {
      id: '/refund-policy'
      path: '/refund-policy'
      fullPath: '/refund-policy'
      preLoaderRoute: typeof RefundPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/supabase-pro-price-bangladesh': {
      id: '/supabase-pro-price-bangladesh'
      path: '/supabase-pro-price-bangladesh'
      fullPath: '/supabase-pro-price-bangladesh'
      preLoaderRoute: typeof SupabaseProPriceBangladeshRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/orders': {
      id: '/account/orders'
      path: '/orders'
      fullPath: '/account/orders'
      preLoaderRoute: typeof AccountOrdersRouteImport
      parentRoute: typeof AccountRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/banners': {
      id: '/admin/banners'
      path: '/banners'
      fullPath: '/admin/banners'
      preLoaderRoute: typeof AdminBannersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/inventory': {
      id: '/admin/inventory'
      path: '/inventory'
      fullPath: '/admin/inventory'
      preLoaderRoute: typeof AdminInventoryRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/orders': {
      id: '/admin/orders'
      path: '/orders'
      fullPath: '/admin/orders'
      preLoaderRoute: typeof AdminOrdersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/payments': {
      id: '/admin/payments'
      path: '/payments'
      fullPath: '/admin/payments'
      preLoaderRoute: typeof AdminPaymentsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/products': {
      id: '/admin/products'
      path: '/products'
      fullPath: '/admin/products'
      preLoaderRoute: typeof AdminProductsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/providers': {
      id: '/admin/providers'
      path: '/providers'
      fullPath: '/admin/providers'
      preLoaderRoute: typeof AdminProvidersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/products/': {
      id: '/products/'
      path: '/'
      fullPath: '/products/'
      preLoaderRoute: typeof ProductsIndexRouteImport
      parentRoute: typeof ProductsRoute
    }
    '/products/$productSlug': {
      id: '/products/$productSlug'
      path: '/$productSlug'
      fullPath: '/products/$productSlug'
      preLoaderRoute: typeof ProductsProductSlugRouteImport
      parentRoute: typeof ProductsRoute
    }
    '/account/orders/': {
      id: '/account/orders/'
      path: '/'
      fullPath: '/account/orders/'
      preLoaderRoute: typeof AccountOrdersIndexRouteImport
      parentRoute: typeof AccountOrdersRoute
    }
    '/account/orders/$orderId': {
      id: '/account/orders/$orderId'
      path: '/$orderId'
      fullPath: '/account/orders/$orderId'
      preLoaderRoute: typeof AccountOrdersOrderIdRouteImport
      parentRoute: typeof AccountOrdersRoute
    }
    '/products/category/$categorySlug': {
      id: '/products/category/$categorySlug'
      path: '/category/$categorySlug'
      fullPath: '/products/category/$categorySlug'
      preLoaderRoute: typeof ProductsCategoryCategorySlugRouteImport
      parentRoute: typeof ProductsRoute
    }
  }
}

interface AccountOrdersRouteChildren {
  AccountOrdersOrderIdRoute: typeof AccountOrdersOrderIdRoute
  AccountOrdersIndexRoute: typeof AccountOrdersIndexRoute
}

const AccountOrdersRouteChildren: AccountOrdersRouteChildren = {
  AccountOrdersOrderIdRoute: AccountOrdersOrderIdRoute,
  AccountOrdersIndexRoute: AccountOrdersIndexRoute,
}

const AccountOrdersRouteWithChildren = AccountOrdersRoute._addFileChildren(
  AccountOrdersRouteChildren,
)

interface AccountRouteChildren {
  AccountOrdersRoute: typeof AccountOrdersRouteWithChildren
}

const AccountRouteChildren: AccountRouteChildren = {
  AccountOrdersRoute: AccountOrdersRouteWithChildren,
}

const AccountRouteWithChildren =
  AccountRoute._addFileChildren(AccountRouteChildren)

interface AdminRouteChildren {
  AdminBannersRoute: typeof AdminBannersRoute
  AdminInventoryRoute: typeof AdminInventoryRoute
  AdminOrdersRoute: typeof AdminOrdersRoute
  AdminPaymentsRoute: typeof AdminPaymentsRoute
  AdminProductsRoute: typeof AdminProductsRoute
  AdminProvidersRoute: typeof AdminProvidersRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminBannersRoute: AdminBannersRoute,
  AdminInventoryRoute: AdminInventoryRoute,
  AdminOrdersRoute: AdminOrdersRoute,
  AdminPaymentsRoute: AdminPaymentsRoute,
  AdminProductsRoute: AdminProductsRoute,
  AdminProvidersRoute: AdminProvidersRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface ProductsRouteChildren {
  ProductsProductSlugRoute: typeof ProductsProductSlugRoute
  ProductsIndexRoute: typeof ProductsIndexRoute
  ProductsCategoryCategorySlugRoute: typeof ProductsCategoryCategorySlugRoute
}

const ProductsRouteChildren: ProductsRouteChildren = {
  ProductsProductSlugRoute: ProductsProductSlugRoute,
  ProductsIndexRoute: ProductsIndexRoute,
  ProductsCategoryCategorySlugRoute: ProductsCategoryCategorySlugRoute,
}

const ProductsRouteWithChildren = ProductsRoute._addFileChildren(
  ProductsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRouteWithChildren,
  AdminRoute: AdminRouteWithChildren,
  AiSubscriptionsBangladeshRoute: AiSubscriptionsBangladeshRoute,
  CartRoute: CartRoute,
  ChatgptPlusPriceBangladeshRoute: ChatgptPlusPriceBangladeshRoute,
  CheckoutRoute: CheckoutRoute,
  GeminiAdvancedPriceBangladeshRoute: GeminiAdvancedPriceBangladeshRoute,
  LovableProPriceBangladeshRoute: LovableProPriceBangladeshRoute,
  OrderSuccessRoute: OrderSuccessRoute,
  PrivacyRoute: PrivacyRoute,
  ProductsRoute: ProductsRouteWithChildren,
  RefundPolicyRoute: RefundPolicyRoute,
  SupabaseProPriceBangladeshRoute: SupabaseProPriceBangladeshRoute,
  SupportRoute: SupportRoute,
  TermsRoute: TermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

import type { getRouter } from './router.tsx'
import type { startInstance } from './start.ts'
declare module '@tanstack/react-start' {
  interface Register {
    ssr: true
    router: Awaited<ReturnType<typeof getRouter>>
    config: Awaited<ReturnType<typeof startInstance.getOptions>>
  }
}
